import ActionTypes from "../constants/ActionTypes";
import BASE_URL from "../constants/Api";
import axiosInstance from "../helpers/refreshTokenMiddleware";
import {utf8ToBase64} from "../helpers/validation";

export const fetchCompanyRequest = () => ({
    type: ActionTypes.FETCH_CAMERA_LIST_REQUEST
});

export const fetchCompanySuccess = (cameras) => ({
    type: ActionTypes.FETCH_CAMERA_LIST_SUCCESS,
    payload: cameras
});

export const fetchCompanyFailure = (error) => ({
    type: ActionTypes.FETCH_CAMERA_LIST_FAILURE,
    payload: error
});


export const fetchCameras = (pageindex, itemsPerPage, company_code, company_name, facility_id, facility_name,device_id,camera_name) => {
    return async (dispatch) => {
        dispatch(fetchCompanyRequest());
        try {
            if (!window.debug) {
                let strFilter = "";
                const maxLength = 255;
                if (company_code) {
                    const trimmed_company_code = company_code.length > maxLength ? company_code.slice(0, maxLength) : company_code;
                    const encoded_company_code = encodeURIComponent(utf8ToBase64(trimmed_company_code));
                    strFilter += `&company_code=${encoded_company_code}`;
                }
                if (company_name) {
                    const trimmed_company_name = company_name.length > maxLength ? company_name.slice(0, maxLength) : company_name;
                    const encoded_company_name = encodeURIComponent(utf8ToBase64(trimmed_company_name));
                    strFilter += `&company_name=${encoded_company_name}`;
                }
                if (facility_id) {
                    const trimmed_facility_id = facility_id.length > maxLength ? facility_id.slice(0, maxLength) : facility_id;
                    const encoded_facility_id = encodeURIComponent(utf8ToBase64(trimmed_facility_id));
                    strFilter += `&facility_id=${encoded_facility_id}`;
                }
                if (facility_name) {
                    const trimmed_facility_name = facility_name.length > maxLength ? facility_name.slice(0, maxLength) : facility_name;
                    const encoded_facility_name = encodeURIComponent(utf8ToBase64(trimmed_facility_name));
                    strFilter += `&facility_name=${encoded_facility_name}`;
                }
                if (device_id) {
                    const trimmed_device_id = device_id.length > maxLength ? device_id.slice(0, maxLength) : device_id;
                    const encoded_device_id = encodeURIComponent(utf8ToBase64(trimmed_device_id));
                    strFilter += `&device_id=${encoded_device_id}`;
                }
                if (camera_name) {
                    const trimmed_camera_name = camera_name.length > maxLength ? camera_name.slice(0, maxLength) : camera_name;
                    const encoded_camera_name = encodeURIComponent(utf8ToBase64(trimmed_camera_name));
                    strFilter += `&camera_name=${encoded_camera_name}`;
                }
                const accessToken = localStorage.getItem('accessTokenCompany');
                // const response = await axiosInstance.get(BASE_URL + `path=camera&type=get-list-data&page=${pageindex}&number_per_page=${itemsPerPage}` + strFilter, 
                const response = await axiosInstance.get(BASE_URL + `path=camera&type=get-list-data` + strFilter, 
                    {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`,
                        }
                    });

                    const data = response.data.respons || {"data_list": [], "all_data_count":0};
                    dispatch(fetchCompanySuccess(data));
            }
            else {
                const data = [{
                    "device_id": "2468800051800111",
                    "camera_name": "2468800051800111",
                    "display_name": "施設１	",
                    // "facility_id": %s,
                    "facility_name": "施設１",
                    // "company_id": %s,
                    // "company_code": %s,
                    "company_name": "MU28_ウォーターエージェンシー",
                    "deleted_row": 0,
                    "gauge_count": 1
                },
                {
                    "device_id": "2468800051800111",
                    "camera_name": "2468800051800111",
                    "display_name": "施設2	",
                    // "facility_id": %s,
                    "facility_name": "施設2",
                    // "company_id": %s,
                    // "company_code": %s,
                    "company_name": "MU28_ウォーターエージェンシー",
                    "deleted_row": 0,
                    "gauge_count": 1
                }
                
                ];
                dispatch(fetchCompanySuccess(data));
            }
        } catch (error) {
            dispatch(fetchCompanyFailure(error.message));
        }
    };
};


